/**
 * Encoding utilities for fv-spatial (fieldview-spatial) URL path parameters.
 *
 * fv-spatial runs on Apache Tomcat, which automatically percent-decodes incoming
 * URL paths once (CVE-2007-0450). The application layer then decodes again.
 * Therefore any value used as a path segment (e.g. pass/crop name) must be
 * double-encoded so the final decoded value matches what fv-spatial has stored.
 */

/**
 * Double-encodes a string for use as an fv-spatial URL path segment.
 */
export function encodeFvSpatialPathSegment(value: string): string {
  return encodeURIComponent(encodeURIComponent(value));
}

/**
 * Decodes a double-encoded fv-spatial path segment back to single-encoded form.
 */
export function decodeFvSpatialPathSegment(value: string): string {
  return decodeURIComponent(value);
}
